import { Colors, IcLocation, IcPhone, Row, Text } from 'basic-ui-lib';
import { IStore } from 'modules/store/interfaces/api';
import styled from 'styled-components';

interface StoreItemMobileProps {
  item: IStore;
  selected?: boolean;
  onClick: () => void;
}

const StoreItemMobile = ({ item, selected = false, onClick }: StoreItemMobileProps) => {
  return (
    <Container onClick={onClick} $selected={selected}>
      <Text content_2 medium left>{item.storeName}</Text>
      <Row gap={8} alignItems='center'>
        <IconWrapper>
          <IcPhone width={16} height={16} fill={Colors.neutral.text[3]} />
        </IconWrapper>
        <Text caption_2 color='neutral.text.6' left>
          {item.phone}
        </Text>
      </Row>
      <Row gap={8} alignItems='center'>
        <IconWrapper>
          <IcLocation width={16} height={16} fill={Colors.neutral.text[3]} />
        </IconWrapper>
        <Text caption_2 color='neutral.text.6' left className='address-text'>
          {item.address}
        </Text>
      </Row>
    </Container>
  );
};

export default StoreItemMobile;

const Container = styled.div<{ $selected: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-radius: 16px;
  padding: 12px 24px;
  border: 1px solid ${({ $selected }) => ($selected ? Colors.primary[6] : Colors.neutral.border[1])};
  background: ${({ $selected }) => ($selected ? Colors.primary[1] : Colors.neutral.bg[1])};
`;

const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-color: ${Colors.neutral.bg[2]};
`;
